module.exports = __webpack_public_path__ + "assets_app/img/audio_play.64cc7cfe.svg";